<script lang="ts">
  export let pwtData: any;
  export let layoutType: string;
  export let size: number;

  import OneLayout from "../common/OneLayout.svelte";

</script>

<div>
  <p>Layout type: <mark>{layoutType}</mark></p>
  <p>
    {#if layoutType === 'delaunay'}
      <span class="layoutInText">Delaunay</span> is a fantastic closepack, mixing large and small canes, which does not exist in real world paperweights.
    {:else if layoutType === 'concentric'}
    <span class="layoutInText">Concentric</span> is a popular existing layout, made of a central unique cane, and concentric circles which use the same cane. 
      Some concentric layouts repeat the same circle multiple times, following a pattern (e.g 1-2-1-2..., or 1-2-3-1-2-3..., or even 1-1-1...).
      The central cane is sometimes very large (even huge), which is typical of Murano concentric paperweights.
    {:else if layoutType === 'closepack'}
      <span class="layoutInText">Closepack</span> is a classic existing design. It consists of packing multiple canes together, as close as possible. In existing paperweights, most of the canes have the same size (even if the central cane is sometimes much larger and complex). It is generated using penny packing layouts. Small places are filled with small canes (which does not exist in real).
    {/if}
  </p>
  <div class="grid">
    <div>
      <div class="title">Flat</div>
      <OneLayout {size} {pwtData} options={{ drawFlat: true, onlyOnce: true, showCanes: false }} />
      <div class="descr">Cane profiles, without being deformed by the glass dome.</div>
    </div>
    <div>
      <div class="title">Projected</div>
      <OneLayout {size} {pwtData} options={{ drawFlat: false, onlyOnce: true, showCanes: false }} />
      <div class="descr">The cane profiles, once projected on the glass dome.</div>
    </div>
    <div>
      <div class="title">Final</div>
      <OneLayout {size} {pwtData} options={{ drawFlat: false, onlyOnce: true, showCanes: true }} />
      <div class="descr">The final paperweight.</div>
    </div>
  </div> 
</div>

<style>
  .title {
    font-size: larger;
    font-weight: bold;
  }
  .descr {
    font-size: smaller;
  }
  .layoutInText {
    font-style: italic;
  }
</style>